/* Kousek štěstí – konverzní úpravy produktové stránky */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Výchozí volba: prostřední varianta (pokud URL neurčuje jinou) */
  function preselectMiddleVariant() {
    if (/[?&]variant=/.test(location.search)) return;
    var radios = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
    if (radios.length < 3) return;
    var target = radios[1];
    if (target && !target.checked && !target.disabled) target.click();
  }

  /* Přilepená lišta s tlačítkem Přidat do košíku (mobil) */
  function setupSticky() {
    var anchor = document.querySelector('.product-form__buttons');
    var realButton = document.querySelector('.product-form__submit');
    if (!anchor || !realButton) return;

    var bar = document.createElement('div');
    bar.className = 'k-sticky-atc';
    bar.innerHTML = '<span class="k-sticky-atc__price"></span>' +
      '<button type="button" class="button button--primary"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('k-has-sticky');

    var priceEl = bar.querySelector('.k-sticky-atc__price');
    var btn = bar.querySelector('button');

    function currentButton() { return document.querySelector('.product-form__submit'); }
    function sync() {
      var b = currentButton();
      if (b) {
        btn.textContent = (b.textContent || '').replace(/\s+/g, ' ').trim();
        btn.disabled = b.disabled || b.getAttribute('aria-disabled') === 'true';
      }
      var p = document.querySelector('.product__info-container .price-item--last');
      priceEl.textContent = p ? p.textContent.trim() : '';
    }
    function toggleBar() {
      var a = document.querySelector('.product-form__buttons');
      if (!a) return;
      var r = a.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }

    btn.addEventListener('click', function () {
      var b = currentButton();
      if (b) b.click();
    });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { toggleBar(); ticking = false; });
    }, { passive: true });

    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(info, { childList: true, subtree: true, characterData: true });
    }
    sync();
    toggleBar();
  }


  /* ====== Popup po přidání do košíku: doprava zdarma + nabídka balení ====== */
  var K = { cfg: null, modal: null, lastFocus: null, cart: null, busy: false };

  function readConfig() {
    try {
      var el = document.getElementById('k-upsell-config');
      K.cfg = el ? JSON.parse(el.textContent) : null;
    } catch (e) { K.cfg = null; }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: currency || 'CZK', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return Math.round(cents / 100) + ' Kč'; }
  }

  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  var ICONS = {
    box: '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-4 9 4-9 4-9-4z"/><path d="M3 8v8l9 4 9-4V8"/><path d="M12 12v8"/></svg>',
    bag: '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>'
  };

  function buildModal() {
    if (K.modal) return K.modal;
    var m = document.createElement('div');
    m.className = 'k-modal';
    m.hidden = true;
    m.innerHTML =
      '<div class="k-modal__backdrop" data-k-close></div>' +
      '<div class="k-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="k-modal-title" tabindex="-1">' +
        '<button type="button" class="k-modal__close" data-k-close aria-label="Zavřít">&times;</button>' +
        '<div class="k-modal__added">' +
          '<span class="k-modal__tick" aria-hidden="true">✓</span>' +
          '<div><h2 id="k-modal-title" class="k-modal__title">Přidáno do košíku</h2><div class="k-modal__item"></div></div>' +
        '</div>' +
        '<div class="k-ship" aria-live="polite"></div>' +
        '<div class="k-upsell"></div>' +
        '<div class="k-modal__actions">' +
          '<a class="button k-modal__cta" href="' + esc(K.cfg ? K.cfg.cartUrl : '/cart') + '">Pokračovat do košíku</a>' +
          '<button type="button" class="k-modal__continue" data-k-close>Pokračovat v nákupu</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-k-close]')) closeModal();
      var btn = e.target.closest('[data-k-pack]');
      if (btn) togglePack(Number(btn.getAttribute('data-k-pack')));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && K.modal && !K.modal.hidden) closeModal();
    });
    K.modal = m;
    return m;
  }

  function renderShip() {
    var box = K.modal.querySelector('.k-ship');
    var cart = K.cart, th = K.cfg.threshold;
    var total = cart.items.reduce(function (a, i) { return a + (i.requires_shipping ? i.final_line_price : 0); }, 0);
    var left = th - total;
    var pct = Math.max(0, Math.min(100, Math.round(total / th * 100)));
    var text = left > 0
      ? 'Do <strong>dopravy zdarma</strong> zbývá ještě <strong>' + money(left, cart.currency) + '</strong>'
      : '🎉 Máte <strong>dopravu zdarma</strong>';
    box.innerHTML =
      '<p class="k-ship__text">' + text + '</p>' +
      '<div class="k-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>' +
      '<p class="k-ship__hint">Zdarma od ' + money(th, cart.currency) + ' · celkem v košíku ' + money(total, cart.currency) + '</p>';
    box.classList.toggle('is-free', left <= 0);
  }

  function inCart(variantId) {
    if (!K.cart) return false;
    return K.cart.items.some(function (i) { return i.variant_id === variantId; });
  }

  function renderUpsell() {
    var box = K.modal.querySelector('.k-upsell');
    var opts = (K.cfg.options || []).filter(function (o) { return o.available; });
    var skip = K.cfg.skipProductIds || [];
    // PREMIUM sada a dvojbalení mají krabičku v ceně: nabídka krabičky se u nich neukazuje (taška zůstává)
    if (K.added && skip.indexOf(Number(K.added.product_id)) !== -1) opts = opts.filter(function (o) { return !o.box; });
    if (!opts.length) { box.hidden = true; return; }
    box.hidden = false;
    var cur = K.cart.currency;
    box.innerHTML =
      '<h3 class="k-upsell__title">Zabalte to jako dárek</h3>' +
      '<p class="k-upsell__note">Krásná dárková krabička je vždy v ceně. Chcete k ní i dárkovou tašku?</p>' +
      '<ul class="k-upsell__list">' + opts.map(function (o) {
        var on = inCart(o.id);
        return '<li class="k-pack' + (on ? ' is-on' : '') + '">' +
          '<span class="k-pack__icon">' + (ICONS[o.icon] || ICONS.box) + '</span>' +
          '<span class="k-pack__body"><strong>' + esc(o.title) + '</strong><span>' + esc(o.desc) + '</span></span>' +
          '<button type="button" class="k-pack__btn" data-k-pack="' + o.id + '" aria-pressed="' + on + '">' +
            (on ? '✓ Přidáno' : '+ ' + money(o.price, cur)) +
          '</button></li>';
      }).join('') + '</ul>';
  }

  function renderAll() {
    renderShip();
    renderUpsell();
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['cart-icon-bubble'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-section');
      if (src) bubble.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  function togglePack(variantId) {
    if (K.busy) return;
    K.busy = true;
    K.modal.classList.add('is-busy');
    var chain = Promise.resolve();
    var turningOn = !inCart(variantId);
    // balení se vylučují: nejdřív odeber všechna ostatní
    (K.cfg.options || []).forEach(function (o) {
      if (inCart(o.id) && (o.id !== variantId || !turningOn)) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: String(o.id), quantity: 0 })
          });
        });
      }
    });
    if (turningOn) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      });
    }
    chain.then(getCart).then(function (cart) {
      K.cart = cart;
      renderAll();
      refreshBubble();
    }).catch(function () {}).then(function () {
      K.busy = false;
      K.modal.classList.remove('is-busy');
    });
  }

  function openModal(item, cart) {
    buildModal();
    K.cart = cart;
    K.added = item;
    var it = K.modal.querySelector('.k-modal__item');
    it.innerHTML =
      (item && item.image ? '<img src="' + esc(item.image) + '" alt="" width="64" height="64" loading="eager">' : '') +
      '<div><strong>' + esc(item ? item.product_title : '') + '</strong>' +
      (item && item.variant_title ? '<span>' + esc(item.variant_title) + '</span>' : '') +
      '<span>' + (item ? money(item.final_price, cart.currency) : '') + '</span></div>';
    renderAll();
    K.lastFocus = document.activeElement;
    K.modal.hidden = false;
    document.documentElement.classList.add('k-modal-open');
    requestAnimationFrame(function () {
      K.modal.classList.add('is-open');
      var cta = K.modal.querySelector('.k-modal__cta');
      if (cta) cta.focus();
    });
  }

  function closeModal() {
    if (!K.modal) return;
    K.modal.classList.remove('is-open');
    document.documentElement.classList.remove('k-modal-open');
    setTimeout(function () { K.modal.hidden = true; }, 200);
    if (K.lastFocus && K.lastFocus.focus) K.lastFocus.focus();
  }

  function setupAddToCartPopup() {
    readConfig();
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-k-add]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      if (!K.cfg) readConfig();
      if (K.busy) return;
      K.busy = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      var added = null;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-k-add')), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Nepodařilo se přidat do košíku.');
          added = (res.body.items && res.body.items[0]) || res.body;
          return getCart();
        })
        .then(function (cart) {
          refreshBubble();
          if (!K.cfg) { window.location.href = '/cart'; return; }
          openModal(added, cart);
        })
        .catch(function (err) { window.alert(err && err.message ? err.message : 'Nepodařilo se přidat do košíku. Zkuste to prosím znovu.'); })
        .then(function () { K.busy = false; btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); });
    });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.closest('.k-modal')) return;
      if (!form.closest('product-form')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (K.busy) return;
      K.busy = true;
      var submit = form.querySelector('[type="submit"]');
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.classList.add('loading'); }
      var data = new FormData(form);
      var added = null;
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Nepodařilo se přidat do košíku.');
          added = res.body;
          return getCart();
        })
        .then(function (cart) {
          refreshBubble();
          openModal(added, cart);
        })
        .catch(function (err) {
          window.alert(err && err.message ? err.message : 'Nepodařilo se přidat do košíku. Zkuste to prosím znovu.');
        })
        .then(function () {
          K.busy = false;
          if (submit) { submit.removeAttribute('aria-disabled'); submit.classList.remove('loading'); }
        });
    }, true);
  }


  /* ====== Košík: dýško a priorita (přepínače) ====== */
  function setupCartExtras() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-k-svc]');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-k-svc');
      var group = btn.getAttribute('data-k-group');
      var on = btn.getAttribute('aria-pressed') === 'true';
      var siblings = Array.prototype.slice.call(document.querySelectorAll('[data-k-group="' + group + '"]'));
      siblings.forEach(function (b) { b.disabled = true; });
      var chain = Promise.resolve();
      var post = function (url, body) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      };
      siblings.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') {
          chain = chain.then(function () { return post('/cart/change.js', { id: b.getAttribute('data-k-svc'), quantity: 0 }); });
        }
      });
      if (!on) chain = chain.then(function () { return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); });
      chain.catch(function () {}).then(function () { window.location.reload(); });
    });
  }

  function setupStickyBar() {
    var bar = document.querySelector('.announcement-bar-section');
    if (!bar) return;
    function measure() {
      document.documentElement.style.setProperty('--k-bar-h', bar.offsetHeight + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(bar);
  }

  function setupCookieBanner() {
    var el = document.getElementById('k-cookie');
    if (!el) return;
    var KEY = 'k_cookie_choice';
    var panel = el.querySelector('.k-cookie__panel');
    var boxA = el.querySelector('[data-k-cat="analytics"]');
    var boxM = el.querySelector('[data-k-cat="marketing"]');
    function stored() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function api() { return window.Shopify && window.Shopify.customerPrivacy; }
    // Rozhoduje jen vlastní uložená volba; výchozí stav Shopify API lištu nesmí skrýt.
    function decided() { return !!stored(); }
    function apply(an, mk) {
      var a = api();
      if (a && typeof a.setTrackingConsent === 'function') {
        try { a.setTrackingConsent({ analytics: an, marketing: mk, preferences: an, sale_of_data: mk }, function () {}); } catch (e) {}
      }
      if (!an || !mk) { try { if (window.fbq && !mk) window.fbq('consent', 'revoke'); } catch (e) {} }
      if (mk) { try { if (window.fbq) window.fbq('consent', 'grant'); } catch (e) {} }
    }
    function syncBoxes() {
      var v = stored() || '';
      boxA.checked = v === 'all' || /(^|,)a(,|$)/.test(v.replace('custom:', ''));
      boxM.checked = v === 'all' || /(^|,)m(,|$)/.test(v.replace('custom:', ''));
    }
    function openPanel(open) {
      panel.hidden = !open;
      el.classList.toggle('is-open', open);
    }
    function show(withPanel) {
      syncBoxes();
      openPanel(!!withPanel);
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    }
    function hide() { el.classList.remove('is-in'); setTimeout(function () { el.hidden = true; }, 300); }
    function choose(an, mk) {
      store(an && mk ? 'all' : (!an && !mk ? 'necessary' : 'custom:' + [an ? 'a' : '', mk ? 'm' : ''].filter(Boolean).join(',')));
      apply(an, mk);
      hide();
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-k-cookie]');
      if (!b) return;
      var act = b.getAttribute('data-k-cookie');
      if (act === 'accept') choose(true, true);
      else if (act === 'reject') choose(false, false);
      else if (act === 'settings') openPanel(panel.hidden);
      else if (act === 'save') choose(boxA.checked, boxM.checked);
    });
    window.kCookieOpen = function () { show(true); };
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-k-cookie-open]');
      if (!t) return;
      e.preventDefault();
      show(true);
    });
    function init() {
      if (decided()) return;
      apply(false, false);
      show(false);
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { init(); });
        return;
      } catch (e) {}
    }
    init();
  }

  function setupCountrySwitch() {
    try {
      var want = sessionStorage.getItem('k_country_try');
      if (want) {
        sessionStorage.removeItem('k_country_try');
        var cur = window.Shopify && window.Shopify.country;
        if (cur && cur !== want && window.console) console.warn('Přepnutí země na ' + want + ' se neuplatnilo, aktivní země: ' + cur);
      }
    } catch (e) {}
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('localization-form a[data-value]');
      if (!a) return;
      var form = a.closest('localization-form').querySelector('form');
      if (!form) return;
      e.preventDefault();
      e.stopPropagation();
      var code = a.getAttribute('data-value');
      if (!code) return;
      try { sessionStorage.setItem('k_country_try', code); } catch (err) {}
      var fd = new FormData(form);
      fd.set('country_code', code);
      fd.set('return_to', window.location.pathname + window.location.search);
      fetch(form.getAttribute('action') || '/localization', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' })
        .catch(function () {})
        .then(function () { window.location.reload(); });
    }, true);
  }

  function localizeFreeShippingTexts() {
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!cur || cur === 'CZK') return;
    var re = /1[\s\u00a0]?299[\s\u00a0]?Kč/g;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      if (re.test(n.nodeValue)) { re.lastIndex = 0; n.nodeValue = n.nodeValue.replace(re, '55\u00a0€'); }
      re.lastIndex = 0;
    }
  }

  function guardCurrency() {
    var S = window.Shopify;
    if (!S || !S.country || !S.currency) return;
    if (S.country === 'CZ' && S.currency.active && S.currency.active !== 'CZK') {
      try { if (sessionStorage.getItem('k_cur_fix')) return; sessionStorage.setItem('k_cur_fix', '1'); } catch (e) { return; }
      try {
        var host = window.location.hostname;
        ['cart_currency', 'cart_currency_override'].forEach(function (n) {
          document.cookie = n + '=; Max-Age=0; path=/';
          document.cookie = n + '=; Max-Age=0; path=/; domain=' + host;
          document.cookie = n + '=; Max-Age=0; path=/; domain=.' + host.replace(/^www\./, '');
        });
      } catch (e) {}
      var fd = new FormData();
      fd.set('form_type', 'localization');
      fd.set('utf8', '✓');
      fd.set('country_code', 'CZ');
      fd.set('return_to', window.location.pathname + window.location.search);
      fetch('/localization', { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' }).catch(function () {}).then(function () { window.location.reload(); });
    }
  }

  function pullSummaryUp() {
    var wrap = document.querySelector('.cart__footer-wrapper');
    var ship = document.querySelector('.k-ship--cart');
    if (!wrap || !ship) return;
    function measure() {
      wrap.style.setProperty('--k-pull', '0px');
      if (window.innerWidth < 1100) return;
      var pull = wrap.getBoundingClientRect().top - ship.getBoundingClientRect().top;
      if (pull > 0) wrap.style.setProperty('--k-pull', Math.round(pull) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    var c = document.querySelector('.cart__items');
    if (window.MutationObserver && c) new MutationObserver(function () { setTimeout(measure, 50); }).observe(c, { childList: true, subtree: true });
  }

  function moveBadgesToPhoto() {
    var b = document.querySelector('.k-pbadges');
    var w = document.querySelector('.product__media-wrapper');
    if (!b || !w) return;
    if (window.getComputedStyle(w).position === 'static') w.style.position = 'relative';
    b.classList.add('k-pbadges--photo');
    w.appendChild(b);
  }

  ready(function () {
    [guardCurrency, localizeFreeShippingTexts, setupCountrySwitch, setupCookieBanner, pullSummaryUp, moveBadgesToPhoto, setupStickyBar, setupCartExtras, setupSticky, setupAddToCartPopup, preselectMiddleVariant].forEach(function (f) {
      try { f(); } catch (err) { if (window.console) console.error(err); }
    });
  });
})();

/* Kousek štěstí – prolínání fotek produktu po najetí myší na kartu (jen zařízení s myší) */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var STEP = 1100;
  var active = null;

  function build(media) {
    if (media._kBuilt) return media._kSlides;
    media._kBuilt = true;
    var urls = (media.getAttribute('data-k-slides') || '').split('|').filter(Boolean);
    var base = media.querySelector('img');
    var slides = urls.map(function (u) {
      var im = document.createElement('img');
      im.className = 'k-slide motion-reduce';
      im.alt = '';
      im.setAttribute('aria-hidden', 'true');
      im.decoding = 'async';
      im.src = u;
      media.appendChild(im);
      return im;
    });
    if (slides.length) {
      var dots = document.createElement('div');
      dots.className = 'k-slide-dots';
      for (var i = 0; i <= slides.length; i++) dots.appendChild(document.createElement('i'));
      media.appendChild(dots);
      media._kDots = dots.children;
    }
    media._kSlides = slides;
    return slides;
  }

  function show(media, idx) {
    var slides = media._kSlides || [];
    slides.forEach(function (im, i) { im.classList.toggle('is-on', i === idx); });
    var d = media._kDots;
    if (d) for (var i = 0; i < d.length; i++) d[i].className = (i === idx + 1) ? 'on' : '';
    media._kIdx = idx;
  }

  function start(media) {
    var slides = build(media);
    if (!slides.length) return;
    stop(active);
    active = media;
    show(media, -1);
    media._kTimer = setTimeout(function tick() {
      var next = (media._kIdx + 1);
      if (next >= slides.length) next = -1;
      show(media, next);
      media._kTimer = setTimeout(tick, STEP);
    }, 350);
  }

  function stop(media) {
    if (!media) return;
    clearTimeout(media._kTimer);
    if (media._kSlides) show(media, -1);
    if (active === media) active = null;
  }

  function mediaOf(target) {
    var card = target.closest && target.closest('.card-wrapper');
    return card ? card.querySelector('.media[data-k-slides]') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var m = mediaOf(e.target);
    if (m && m !== active) start(m);
  });
  document.addEventListener('mouseout', function (e) {
    var m = mediaOf(e.target);
    if (!m) return;
    var to = e.relatedTarget;
    if (to && m.closest('.card-wrapper').contains(to)) return;
    stop(m);
  });
})();

/* Galerie produktu: velký náhled s přepínáním přejetím (swipe), šipkami a klávesnicí */
(function () {
  var lb = null;

  function build() {
    lb = document.createElement('div');
    lb.className = 'k-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.hidden = true;
    lb.innerHTML =
      '<button type="button" class="k-lb__close" aria-label="Zavřít">&times;</button>' +
      '<button type="button" class="k-lb__nav k-lb__nav--prev" aria-label="Předchozí fotka">&#8249;</button>' +
      '<button type="button" class="k-lb__nav k-lb__nav--next" aria-label="Další fotka">&#8250;</button>' +
      '<div class="k-lb__track"></div>' +
      '<div class="k-lb__count" aria-live="polite"></div>';
    document.body.appendChild(lb);

    var track = lb.querySelector('.k-lb__track');
    lb.querySelector('.k-lb__close').addEventListener('click', close);
    lb.querySelector('.k-lb__nav--prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.k-lb__nav--next').addEventListener('click', function () { go(1); });
    track.addEventListener('click', function (e) { if (e.target === track || e.target.classList.contains('k-lb__slide')) close(); });
    track.addEventListener('scroll', function () { updateCount(); }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
  }

  function index() {
    var t = lb.querySelector('.k-lb__track');
    return Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
  }

  function updateCount() {
    var t = lb.querySelector('.k-lb__track');
    var n = t.children.length;
    lb.querySelector('.k-lb__count').textContent = n > 1 ? (index() + 1) + ' / ' + n : '';
    lb.classList.toggle('k-lb--single', n < 2);
  }

  function go(d) {
    var t = lb.querySelector('.k-lb__track');
    t.scrollTo({ left: (index() + d) * t.clientWidth, behavior: 'smooth' });
  }

  function close() {
    lb.hidden = true;
    document.documentElement.classList.remove('k-lb-open');
    if (lb._opener) { try { lb._opener.focus(); } catch (e) {} }
  }

  function open(opener) {
    var modal = document.querySelector('product-modal');
    if (!modal) return false;
    var items = modal.querySelectorAll('[data-media-id]');
    var slides = [], start = 0, id = opener.getAttribute('data-media-id');
    items.forEach(function (el) {
      var img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('src') || img.currentSrc;
      if (!src) return;
      if (el.getAttribute('data-media-id') === id) start = slides.length;
      slides.push({ src: src, alt: img.getAttribute('alt') || '' });
    });
    if (!slides.length) return false;
    if (!lb) build();
    var track = lb.querySelector('.k-lb__track');
    track.innerHTML = '';
    slides.forEach(function (s) {
      var d = document.createElement('div');
      d.className = 'k-lb__slide';
      var im = document.createElement('img');
      im.src = s.src; im.alt = s.alt; im.draggable = false;
      d.appendChild(im);
      track.appendChild(d);
    });
    lb._opener = opener;
    lb.hidden = false;
    document.documentElement.classList.add('k-lb-open');
    track.scrollLeft = start * track.clientWidth;
    updateCount();
    lb.querySelector('.k-lb__close').focus();
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product__media-toggle');
    if (!btn) return;
    if (open(btn)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();

/* Video v galerii produktu se samo spustí (ztlumené), jakmile je vidět */
(function () {
  function init() {
    var vids = document.querySelectorAll('.product__media-item deferred-media, .product__media-list deferred-media');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        if (!en.isIntersecting || el.hasAttribute('loaded')) return;
        io.unobserve(el);
        try { el.loadContent(false); } catch (e) {}
        var v = el.querySelector('video');
        if (v) { v.muted = true; v.setAttribute('playsinline', ''); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }, { threshold: 0.6 });
    vids.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
